import { IFilter } from "@/models/filter.model";
import { ITimePeriodFilter } from "@/models/timePeriod.model";

export type Direction = "asc" | "desc" | "alphanumericAsc" | "alphanumericDesc"

export enum MoveItemDirection {
  Next = "next",
  Previous = "previous"
}

export enum ObjectionCategory {
  NEED = "Need",
  TIME = "Time",
  TRUST = "Trust",
  COST = "Cost",
}

export enum ViewStatePlateType {
  active = "Active",
  completed = "Completed",
  draft = "Draft",
  inactive = "Inactive",
  inProgress = "In Progress",
  paused = "Paused",
}

// McFileUploader's "select:file": the picked or dropped file, and whether its type and size pass.
export interface IFileUploaderSelectEvent {
  file: File;
  isValid: boolean;
  errorMessage: string | undefined;
}

export interface IOption<TValue> {
  value: TValue;
  name: string;
  icon?: string;
  dividerAfter?: boolean;
  sequence?: number;
  tooltip?: string;
  disabled?: boolean;
  description?: string;
}

export interface ISelectOption<TValue> extends IOption<TValue> {
  selected?: boolean;
  intermediate?: boolean;
  childItems?: ISelectOption<any>[];
  filteredChildItems?: ISelectOption<any>[];
}

export interface IQueryStringFilter {
  campaignId?: number;
  teamId?: number;
  userId?: number;
  interactionsSearch?: string;
  isSuccess?: boolean;
  objectionName?: string;
  objectionCategory?: string;
  sentiment?: string;
  peakSentiment?: string;
  endSentiment?: string;
  topic?: string;
  resultCode?: string;
  duration?: string;
  startDate?: Date;
  endDate?: Date;
  list?: string;
  dataSupplierId?: number;
}

export interface ITreeItemFilter {
  value: string;
  selectedAll: boolean;
  childItems: string[];
}

export interface IObjectionReasonMetrics {
  category: string;
  date: string | Date;
  objection: string;
  occurrencesNumber: number;
  successConversationNumber: number;
}

export interface ICheckbox {
  label: string;
  checked: boolean;
  color?: string;
  value?: string;
  intermediate?: boolean;
}

export interface ISharedLinkFilter {
  advancedFilter: IFilter;
  timePeriodFilter: ITimePeriodFilter;
  linkId: string;
  quickFilterId?: string;
}

export interface IAnalyticsJobFilter {
  advancedFilter: IFilter;
  timePeriodFilter: ITimePeriodFilter;
  jobId: string;
  quickFilterId?: string;
}

export interface IPaginationInfo {
  currentPage: number;
  perPage: number;
  from?: number | undefined;
  to?: number | undefined;
  totalItems?: number | undefined;
}

export interface IValidationInfo {
  htmlElementId: string;
  isValid?: boolean;
  errorMessage?: string;
}

export interface IValidationInfoMessage {
  iconCssClass?: string;
  title?: string;
  message: string;
  isLoading?: boolean;
  isValid: boolean;
}